import { apiService } from '../api';
import {
  AdmissionEnquiry,
  AdmissionEnquiriesListResponse,
  AdmissionEnquiryInput,
  AdmissionEnquiryStatus,
} from '../../types/admissions';

/** Wraps /api/admission-enquiries — families interested in a future admission. */
export const admissionEnquiryService = {
  list: async (params: {
    forYear?: number;
    classId?: string;
    status?: AdmissionEnquiryStatus;
    q?: string;
    page?: number;
    limit?: number;
  }): Promise<AdmissionEnquiriesListResponse> => {
    const r = await apiService.get<AdmissionEnquiriesListResponse>('/admission-enquiries', params);
    return r.data!;
  },

  /** Every enquiry matching the filters, for an export — pages through at the API's maximum page size. */
  listAll: async (params: { forYear?: number; classId?: string; status?: AdmissionEnquiryStatus; q?: string }): Promise<AdmissionEnquiry[]> => {
    const items: AdmissionEnquiry[] = [];
    for (let page = 1; ; page += 1) {
      // eslint-disable-next-line no-await-in-loop -- pages are sequential by nature
      const r = await apiService.get<AdmissionEnquiriesListResponse>('/admission-enquiries', { ...params, page, limit: 100 });
      items.push(...r.data!.items);
      if (!r.data!.pagination.hasNext) return items;
    }
  },

  create: async (payload: AdmissionEnquiryInput): Promise<AdmissionEnquiry> => {
    const r = await apiService.post<AdmissionEnquiry>('/admission-enquiries', payload);
    return r.data!;
  },

  update: async (id: string, payload: Partial<AdmissionEnquiryInput> & { status?: AdmissionEnquiryStatus }): Promise<AdmissionEnquiry> => {
    const r = await apiService.patch<AdmissionEnquiry>(`/admission-enquiries/${id}`, payload);
    return r.data!;
  },

  remove: async (id: string): Promise<void> => {
    await apiService.delete(`/admission-enquiries/${id}`);
  },
};
